import { Text } from '@shared/components';

import { formatMillisecondsToMinutesSeconds } from '../../utils';

export default function ExtendedDurationCell({
  value,
  disabled,
}: {
  value: number;
  disabled?: boolean;
}) {
  const parts = formatMillisecondsToMinutesSeconds(value);

  if (!parts) return null;

  if (disabled) {
    return (
      <Text variant='body1' component='span' color='inherit'>
        {parts.minutes}m {parts.seconds}s
      </Text>
    );
  }

  if (value === 0) {
    return (
      <Text variant='body1' component='span' color='text.disabled'>
        {parts.minutes}m {parts.seconds}s
      </Text>
    );
  }

  return (
    <Text variant='body1' component='span' color='text.secondary'>
      <Text variant='body1Semibold' component='span' color='text.primary'>
        {parts.minutes}
      </Text>
      m{' '}
      <Text variant='body1Semibold' component='span' color='text.primary'>
        {parts.seconds}
      </Text>
      s
    </Text>
  );
}
